<template>
  <div>
    <v-card-title primary-title class="headline mast-header" :style="bg">Recreational Vessel Registration Fees</v-card-title>
    <v-card-text>
      <div>
        <v-form ref="form" @submit.prevent="submit" autocomplete="off">
          <div>
            <slot name="form">
              <date-field label="Start Date*" v-model="startDate" :today="true"/>
            </slot>
          </div>
          <div class="captcha-container">
            <div>
              <h4 v-if="badRequest" class="red--text">
                Could not locate Fee Table. Please contact MAST Online
              </h4>
              <div v-else-if="answer">
                <h4>Cost: ${{answer.toFixed(2)}}</h4>
                <small>Pro rata to {{answerSubtitle}}</small>
              </div>
              <h4 v-else-if="isNaN(answer)" class="red--text">
                Could not calculate estimate. Please contact MAST Online
              </h4>
            </div>
            <v-btn type="submit" :disabled="!canSubmit">Calculate</v-btn>
          </div>
        </v-form>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import EditField from '@/components/edit-field'
import DateField from '@/components/date-field'
import API from '@/api'
import bg from '@/assets/mast.png'

import moment from 'moment'

export default {
  name: 'checker-view',
  inject: ['$validator'],
  components: { EditField, DateField },
  computed: {
    mobile () {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    canSubmit () {
      return this.feeValues && !this.errors.any()
    },
    bg () {
      return `background-image:url(${bg})`
    }
  },
  data () {
    return {
      length: '',
      startDate: '',
      badRequest: false,
      feeValues: {},
      answer: 0,
      answerSubtitle: ''
    }
  },
  async mounted () {
    this.$validator.validateAll()
    const response = await API.getFeeTable('/recreational-fees/')
    if (response._success) {
      this.feeValues = response
    } else {
      this.badRequest = true
    }
  },
  methods: {
    getLeapDays (startDate, endDate) {
      let start = moment([startDate.year(), 1, 28])
      let days = 0
      while (endDate.diff(start, 'days') > 0) {
        if (
          start.isLeapYear() &&
          startDate.diff(start, 'days') <= 0 &&
          endDate.diff(start, 'days') > 0
        ) {
          days += 1
        }
        start = start.add(1, 'years')
      }
      return days
    },
    submit () {
      this.$validator.validateAll()
      if (!this.canSubmit) return

      const { application_fee, base_fee } = this.feeValues
      this.$validator.validateAll()
      if (!this.canSubmit) return

      let startDate = moment(this.startDate)
      let endDate = moment([startDate.year(), 11, 31])
      let diff = endDate.diff(startDate, 'days') + 2
      if (diff <= 61) {
        endDate = moment([startDate.year() + 1, 11, 31])
        diff = endDate.diff(startDate, 'days') + 2
      }
      diff -= this.getLeapDays(startDate, endDate)

      let unitPrice = parseFloat(base_fee)
      let registrationPrice = parseFloat(application_fee)

      this.answer = unitPrice ? registrationPrice + Math.round(diff * unitPrice / 365 * 100) / 100 : NaN
      this.answerSubtitle = endDate.format('Do MMMM, YYYY')
      console.log(diff, endDate, this.answer)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/recreational-fees.vue